import React, { memo, useCallback, useState } from 'react'

import { bool, func, number, shape, string } from 'prop-types'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import Actions from './Components/Actions/Actions'
import Lightbox from './Components/Lightbox/Lightbox'

// Completed turn: the generated image and the apply / regenerate / edit / download
// actions. The image doubles as the trigger for the lightbox that shows it large.
function Result({ result, isGenerating, onApply, onRegenerate, onEdit }) {
  const t = useTranslation()
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)

  const handleOpenLightbox = useCallback(() => setIsLightboxOpen(true), [])
  const handleCloseLightbox = useCallback(() => setIsLightboxOpen(false), [])

  return (
    <>
      <div className="image-assistant-create-tab__result">
        <div className="image-assistant-create-tab__result-image-wrapper">
          <button
            type="button"
            className="image-assistant-create-tab__result-image-button"
            aria-label={t('imageAssistantPanel.createTab.result.expand')}
            onClick={handleOpenLightbox}
          >
            <img className="image-assistant-create-tab__result-image" src={result.url} alt={result.alt} />
          </button>
        </div>
        <Actions
          result={result}
          isGenerating={isGenerating}
          className="image-assistant-create-tab__result-actions"
          onApply={onApply}
          onRegenerate={onRegenerate}
          onEdit={onEdit}
        />
      </div>
      {isLightboxOpen && (
        <Lightbox
          result={result}
          isGenerating={isGenerating}
          onApply={onApply}
          onRegenerate={onRegenerate}
          onEdit={onEdit}
          onClose={handleCloseLightbox}
        />
      )}
    </>
  )
}

Result.propTypes = {
  result: shape({ id: number, url: string, alt: string }).isRequired,
  isGenerating: bool.isRequired,
  onApply: func.isRequired,
  onRegenerate: func.isRequired,
  onEdit: func.isRequired,
}

export default memo(Result)
